import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { EventInvitationCollectionPayload } from '../types';
import { EmailTemplatesEventInvitationHttpClient } from './event-invitation-http-client';
import { EmailTemplatesEventInvitationActions } from './event-invitation.store';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesEventInvitationEffects {
  public effects = createEffectFactory(EmailTemplatesEventInvitationActions, this.actions$);

  public fetchCollection$ = this.effects(
    EmailTemplatesEventInvitationActions.fetchCollection,
    ({ payload }) =>
      payload!.scope !== 'main'
        ? this.emailTemplatesEventInvitationHttpClient
            .loadCollection(<EventInvitationCollectionPayload>{ includeLastUsed: payload!.scope })
            .pipe(map(data => ({ data })))
        : this.emailTemplatesEventInvitationHttpClient
            .loadCollection()
            .pipe(map(data => ({ data }))),
    { customMapOperator: mergeMap },
  );

  public saveTemplate$ = this.effects(
    EmailTemplatesEventInvitationActions.createOnePessimistic,
    ({ payload }) =>
      this.emailTemplatesEventInvitationHttpClient
        .create(payload.data)
        .pipe(map(data => ({ data }))),
  );

  public deleteTemplate$ = this.effects(
    EmailTemplatesEventInvitationActions.removeOnePessimistic,
    ({ payload: { data } }) =>
      this.emailTemplatesEventInvitationHttpClient.delete(data).pipe(map(data => ({ data }))),
  );

  public updateTemplate$ = this.effects(
    EmailTemplatesEventInvitationActions.updateOnePessimistic,
    ({ payload: { data } }) =>
      this.emailTemplatesEventInvitationHttpClient.update(data).pipe(map(data => ({ data }))),
  );

  public updatePositions$ = this.effects(
    EmailTemplatesEventInvitationActions.updatePositions,
    ({ payload }) =>
      this.emailTemplatesEventInvitationHttpClient.updatePositions(payload).pipe(
        map(data =>
          EmailTemplatesEventInvitationActions.updatePositionsSuccess({ payload: { data } }),
        ),
        catchError(error =>
          of(EmailTemplatesEventInvitationActions.updatePositionsFailed({ payload: error })),
        ),
      ),
  );

  public duplicateTemplate$ = this.effects(
    EmailTemplatesEventInvitationActions.duplicateTemplate,
    ({ payload }) =>
      this.emailTemplatesEventInvitationHttpClient.duplicate(payload).pipe(
        map(template =>
          EmailTemplatesEventInvitationActions.duplicateTemplateSuccess({
            payload: { data: template, correlationId: payload.correlationId },
          }),
        ),
        catchError(error =>
          of(EmailTemplatesEventInvitationActions.duplicateTemplateFailed({ payload: error })),
        ),
      ),
  );

  constructor(
    private emailTemplatesEventInvitationHttpClient: EmailTemplatesEventInvitationHttpClient,
    private actions$: Actions,
  ) {}
}
